const BillableTotalTimeAndExpensesAtCompletionLowerWinChanceTooltip = formatMessage => [
	{
		title: formatMessage({id: 'insights.baseline_tooltip_forecast_revenue'}),
		details: [formatMessage({id: 'project.win_chance'}), 'x', formatMessage({id: 'project_budget.baseline_revenue'})],
	},
	{
		description: formatMessage({id: 'insights.baseline_tooltip_text_revenue'}),
	},
];

const TotalCostAtCompletionLowerWinChanceTooltip = formatMessage => [
	{
		title: formatMessage({id: 'insights.baseline_tooltip_forecast_cost'}),
		details: [formatMessage({id: 'project.win_chance'}), 'x', formatMessage({id: 'project_budget.baseline_cost'})],
	},
	{
		description: formatMessage({id: 'insights.baseline_tooltip_text_cost'}),
	},
];
const GenericWinChanceTooltip = formatMessage => [
	{
		title: formatMessage({id: 'placeholder.win_probability.project_portfolio.applied_tooltip_header'}),
		description: formatMessage({id: 'placeholder.win_probability.project_portfolio.applied_tooltip'}),
	},
];

export const ProjectPortfolioReportTooltips = {
	BillableTotalTimeAndExpensesAtCompletionLowerWinChanceTooltip,
	TotalCostAtCompletionLowerWinChanceTooltip,
	GenericWinChanceTooltip,
};
